function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import AssetStripComponent from "/components/core/asset-strip/asset-strip-component";
import ArticleItemComponent from "../article-item/article-item-component";
import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import { withAbTests } from "/contexts/ab-tests-context";
import { StyledArticleTemplateContentComponent } from "./article-template-content-component.scss";
class ArticleTemplateContentComponent extends PureComponent {
    shouldRenderFooterSignupForm() {
        const { footerSignup } = this.props;
        return footerSignup && !footerSignup.preventSignup;
    }
    render() {
        const { headerStrip, parts, footerSignup, footerDisclaimer, abTests } = this.props;
        const shouldFocusOnSignup = true;
        return /*#__PURE__*/ _jsxs(StyledArticleTemplateContentComponent, {
            className: "article-template-content-component",
            children: [
                headerStrip && /*#__PURE__*/ _jsx(AssetStripComponent, {
                    asset: headerStrip.asset,
                    title: headerStrip.title,
                    subtitle: headerStrip.subtitle,
                    preventSignup: headerStrip.preventSignup,
                    signupFocusOnLoad: shouldFocusOnSignup
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "article-items-list",
                    children: parts.map((part, index)=>/*#__PURE__*/ _jsx(ArticleItemComponent, _object_spread({
                            partType: part.type
                        }, part.props), index))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "content-footer-signup-wrapper",
                    children: this.shouldRenderFooterSignupForm() && /*#__PURE__*/ _jsx(SignupWithTextComponent, {
                        title: footerSignup.title,
                        subtitle: footerSignup.subtitle
                    })
                }),
                footerDisclaimer && /*#__PURE__*/ _jsx("div", {
                    className: "footer-disclaimer",
                    dangerouslySetInnerHTML: {
                        __html: footerDisclaimer
                    }
                })
            ]
        });
    }
}
export default withAbTests(ArticleTemplateContentComponent);
